module.exports = __webpack_public_path__ + "static/6329-b921dfabb551f8c586f0c18778a084f9.png";